// extracted by mini-css-extract-plugin
export default {"launcher":"R_fY","launcher__heading":"R_fZ","launcher__menu-item":"R_f0"};